import "core-js/modules/es.array.push.js";
import { Popup as VanPopup, showToast, closeToast, showLoadingToast } from 'vant';
export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    src: {
      type: String,
      default: ''
    },
    poster: {
      type: String
    },
    muted: {
      type: Boolean,
      default: false
    }
  },
  components: {
    VanPopup
  },
  emits: ['update:modelValue'],
  data() {
    return {
      visible: this.modelValue,
      showAction: false,
      actions: [{
        name: this.$t('cfmoto.saveVideo'),
        value: 'writePhotosAlbum'
      }]
    };
  },
  computed: {
    // isApp() {
    //   return true;
    // },
  },
  methods: {
    handlePress(e) {
      if (this.isApp) {
        this.showAction = true;
      }
    },
    onChange(index) {
      this.position = index;
    },
    onCancel() {
      this.visible = false;
    },
    async onSelect(item, index) {
      try {
        if (item.value === 'writePhotosAlbum') {
          if (!this.isApple) {}
          const resSettings = await new Promise((resolve, reject) => window.cfmoto.openAppAuthorizeSetting({
            name: 'writePhotosAlbum',
            success: resolve,
            fail: reject
          }));
          showLoadingToast({
            forbidClick: true,
            duration: 0,
            overlay: true,
            message: ''
          });
          const res = await new Promise(resolve => window.cfmoto.saveVideoToPhotosAlbum({
            url: this.src,
            success: resolve,
            fail: resolve
          }));
          closeToast();
          if (res.errCode !== 200) {
            showToast(res.errMsg);
            return;
          }
          showToast(this.$t('cfmoto.saveSuccess'));
        }
      } catch (error) {
        // showToast(JSON.stringify(error));
        throw new Error(error);
      } finally {
        setTimeout(() => {
          this.showAction = false;
        }, 300);
      }
    }
  },
  created() {
    this.visible = this.modelValue;
  },
  mounted() {
    document.body.appendChild(this.$el);
  },
  beforeUnmount() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },
  watch: {
    modelValue(newValue) {
      this.visible = newValue;
    },
    visible: {
      immediate: true,
      handler(newValue) {
        this.$emit('update:modelValue', newValue);
        if (newValue) {
          this.$router.push({
            query: {
              ...this.$route.query,
              previewVideo: 'true'
            }
          });
        } else {
          this.$nextTick(() => {
            if (this.$route.query.previewVideo) this.$router.back();
          });
        }
      }
    }
  }
};